// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3U5TQ","footer":"ModalError_footer__1HB-T"};